/**
 * Radix Dialog outside-click／focus：若落在 react-select portaled menu 上則應忽略。
 * 依賴 SelectCore `classNamePrefix="react-select"`。
 */
export function isEventFromReactSelectMenu(event) {
  let target = event?.target;
  if (!target) {
    return false;
  }
  if (!(target instanceof Element)) {
    target = target.parentElement;
  }
  if (!(target instanceof Element)) {
    return false;
  }

  return Boolean(
    target.closest('.react-select__menu')
    || target.closest('.react-select__menu-portal'),
  );
}
